import React, { createContext, useContext, useState, type ReactNode } from "react";
import type { EmotionalState } from "@/lib/petLogic";

interface ChatHeaderData {
  dogState: EmotionalState;
  statusPhrase: string;
  soundEnabled: boolean;
  setSoundEnabled: (v: boolean) => void;
  streak: number;
  isKids: boolean;
  isMemorial: boolean;
  canShowBreedButton: boolean;
  showWalkTimer: boolean;
  setShowWalkTimer: (v: boolean | ((prev: boolean) => boolean)) => void;
}

interface ChatHeaderContextType {
  data: ChatHeaderData | null;
  setData: (data: ChatHeaderData | null) => void;
}

const ChatHeaderContext = createContext<ChatHeaderContextType>({
  data: null,
  setData: () => {},
});

export const ChatHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setData] = useState<ChatHeaderData | null>(null);
  return (
    <ChatHeaderContext.Provider value={{ data, setData }}>
      {children}
    </ChatHeaderContext.Provider>
  );
};

export const useChatHeaderData = () => useContext(ChatHeaderContext);
